<script setup lang="ts">
  import { useApiRequestsAbort } from '@/shared/composables'
  import { TravelDirection } from '@/shared/types/common.types'
  import { FlowContactsWidgetQC } from '@/widgets/Flow'

  useApiRequestsAbort()
</script>

<template>
  <FlowContactsWidgetQC :type-of-travel="TravelDirection.INBOUND" />
</template>
